import { useNavigate } from 'react-router-dom';
import Experience from './sections/Experience';
import ListView from './sections/ListView';
import './style.css';
import SkillTable from './sections/SkillChart';
import { add_skills, intro, responsibility } from '../../data';

export default function SkillPage(params) {
  const navigate = useNavigate();

  return (
    <div className="skillPage">
      <div className="main">
        <div className="heading">
          <h1>
            Skills &
            <br />
            Experience
          </h1>
        </div>
        <div className="flex flex-col-reverse lg:flex-row">
          <div className="leftPart w-full lg:w-1/2 ">
            <div className="paragraph">
              <p>{intro}</p>
              <p>{add_skills}</p>
              <p>
                Visit my
                <span
                  onClick={() =>
                    window.open(
                      'https://www.linkedin.com/in/md-amanullah-sayeem-77922b18a/',
                      '_blank'
                    )
                  }
                >
                  Linkedin
                </span>
                profile for more details or just
                <span>
                  <span onClick={() => navigate('/contact')}>contact</span>
                </span>
                me.
              </p>
            </div>

            <div className="responsibility">
              <div className="heading ml-2">
                <h1 className="text-secondary-300">What I do</h1>
              </div>
              <div className="listContainer">
                <div className="ml-14">
                  <ListView list={responsibility} />
                </div>
              </div>
            </div>
          </div>
          <div className="rightPart px-14 lg:px-14 py-4 w-full lg:w-1/2">
            <SkillTable />
            <div className="pt-14 experience">
              <Experience />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
